import React from 'react';
import ReactDOM from 'react-dom';
import {Container, Row, Col} from 'react-grid-system';
import {Drawable} from "../../../../../res/images/Drawable";

interface States {

}

interface Props {
}

class AndroidLogo extends React.Component<Props, States> {

    state: States

    constructor(props: Props) {
        super(props)
        this.state = {}

    }

    render() {
        return (
            <Col
                className="imageContainer"
                lg={6}>
                <img
                    className="androidLogo"
                    src={Drawable.androidLogo}/>
            </Col>
        )
    }
}

export default AndroidLogo;
